import { render } from "./consumable.vue?vue&type=template&id=60f3c9cc&scoped=true"
import script from "./consumable.vue?vue&type=script&lang=js"
export * from "./consumable.vue?vue&type=script&lang=js"

import "./consumable.vue?vue&type=style&index=0&id=60f3c9cc&lang=scss&scoped=true"

import exportComponent from "/data/jenkins-workspace/workspace/Publicar_automáticamente_por_Lianxin/联心运营后台前端【生产】/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f3c9cc"]])

export default __exports__